// @flow

// Constants
import {
  PROP_USERNAME,
} from 'fc-model-users'

// Selectors
import authenticatedUser$ from './authenticatedUser'

// Utils
import traverse from 'fc-utils/traverse'

const getUsername = traverse([PROP_USERNAME], {
  default: '',
})

// Exports
export default (state: {}): string => {
  return getUsername(authenticatedUser$(state))
}
